export * from "./store-rider.component";
